"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.product = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const spaces_1 = require("../basic/spaces");
exports.product = (0, basic_1.applyBase)({
    productDescriptionWrap: {
        background: 'white',
        margin: [4, 0],
        '.block': Object.assign(Object.assign({ paddingTop: spaces_1.space[1], paddingBottom: spaces_1.space[1] }, font_faces_1.FONT_SIZE.LARGE), { h3: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.S), { marginBottom: [1, 3] }) }),
        '.lead-text': Object.assign({}, font_faces_1.FONT_SIZE.LARGE_BOLD),
    },
    featuresListWrapper: {
        borderTop: '1px solid',
        borderColor: 'borderColor',
        pt: 3,
        pb: 2,
        '.features-list': Object.assign({}, font_faces_1.FONT_SIZE.LARGE),
        '.features-item': {
            mb: 1,
        },
        '.feature-icon-wrapper': {
            verticalAlign: [`sub`, `middle`],
            mr: 2,
        },
    },
    featuresHeadingWrapper: {
        display: 'flex',
        alignItems: 'center',
        mb: 3,
        '.icon': {
            mr: 2,
        },
        '.features-heading': Object.assign({}, font_faces_1.FONT_SIZE.XS),
    },
});
//# sourceMappingURL=product.js.map